// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import { Spinner } from 'react-bootstrap';
// import axios from 'axios';
// import { BASE_URL } from '../../../services/Api';
// import { authHeader } from '../../../services/auth-header';
// import '../PumpSpareInternational/PrintPSI.css';

// const SalesInvoicePrintAMI = () => {
//     const { id } = useParams();
//     const [isLoading, setIsLoading] = useState(true);
//     const [salesData, setSalesData] = useState(null);
//     const [rows, setRows] = useState([]);
//     const [currency, setCurrency] = useState('JPY'); // Default to JPY
//     const [uom, setUom] = useState('Nos.'); // Default to Nos.

//     const fetchSalesData = async () => {
//         try {
//             const response = await axios.get(`${BASE_URL}sales/findById/${id}`, {
//                 headers: authHeader(),
//             });

//             const data = response.data;
//             setSalesData(data);
//             console.log("Fetched sales data:", data);

//             if (data.salesItems && data.salesItems.length > 0) {
//                 // Get currency and UOM from first item
//                 const firstItem = data.salesItems[0];
//                 const itemCurrency = firstItem.currency || 'JPY';
//                 const itemUom = firstItem.uom || 'Nos.';

//                 setCurrency(itemCurrency);
//                 setUom(itemUom);

//                 setRows(data.salesItems.map(item => ({
//                     description: item.product?.description || '-',
//                     productremarks: item.productremarks || '',
//                     quantity: item.quantity || 0,
//                     unitratecurrency: item.unitratecurrency || 0,
//                     totalcurrency: item.totalcurrency || 0,
//                     uom: item.uom || itemUom, // Use item's UOM or fallback to first item's UOM
//                 })));
//             }
//         } catch (error) {
//             console.error("Error fetching sales data", error);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchSalesData();
//     }, [id]);

//     // Format functions...
//     const formatDate = (dateString) => {
//         if (!dateString) return 'N/A';
//         try {
//             const date = new Date(dateString);
//             if (isNaN(date.getTime())) return 'N/A';
//             const day = date.getDate().toString().padStart(2, '0');
//             const month = (date.getMonth() + 1).toString().padStart(2, '0');
//             const year = date.getFullYear();
//             return `${day}.${month}.${year}`;
//         } catch (error) {
//             return 'N/A';
//         }
//     };

//     const formatNumberWithCommas = (num) => {
//         if (isNaN(num) || num === null || num === undefined) return '0';
//         return parseInt(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//     };

//     const formatNumberWithDecimal = (num) => {
//         if (isNaN(num) || num === null || num === undefined) return '0.00';
//         return parseFloat(num).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//     };

//     const numberToWordsWithCurrency = (num, currency = 'JPY') => {
//         if (isNaN(num) || num === null || num === undefined) {
//             return "Zero Only";
//         }

//         const amount = Math.round(Number(num));

//         // Indian number system conversion
//         const getIndianNumberWords = (num) => {
//             const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
//                 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
//                 'Eighteen', 'Nineteen'];
//             const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
//             const scales = ['', 'Thousand', 'Lakh', 'Crore'];

//             if (num === 0) return 'Zero';
//             if (num < 20) return ones[num];

//             let words = '';

//             // Convert to Indian numbering system
//             let n = num;
//             let scaleIndex = 0;
//             const parts = [];

//             while (n > 0) {
//                 if (scaleIndex === 0) {
//                     // Handle last three digits
//                     let lastThree = n % 1000;
//                     if (lastThree > 0) {
//                         let part = '';
//                         if (lastThree >= 100) {
//                             part += ones[Math.floor(lastThree / 100)] + ' Hundred ';
//                             lastThree %= 100;
//                         }
//                         if (lastThree >= 20) {
//                             part += tens[Math.floor(lastThree / 10)] + ' ';
//                             lastThree %= 10;
//                         }
//                         if (lastThree > 0) {
//                             part += ones[lastThree] + ' ';
//                         }
//                         parts.unshift(part.trim() + (scales[scaleIndex] ? ' ' + scales[scaleIndex] : ''));
//                     }
//                     n = Math.floor(n / 1000);
//                     scaleIndex++;
//                 } else {
//                     // Handle in pairs (lakhs, crores)
//                     let lastTwo = n % 100;
//                     if (lastTwo > 0) {
//                         let part = '';
//                         if (lastTwo >= 20) {
//                             part += tens[Math.floor(lastTwo / 10)] + ' ';
//                             lastTwo %= 10;
//                         }
//                         if (lastTwo > 0) {
//                             part += ones[lastTwo] + ' ';
//                         }
//                         parts.unshift(part.trim() + ' ' + scales[scaleIndex]);
//                     } else if (n % 100 !== 0) {
//                         parts.unshift(scales[scaleIndex]);
//                     }
//                     n = Math.floor(n / 100);
//                     scaleIndex++;
//                 }
//             }

//             return parts.join(' ').trim();
//         };

//         const words = getIndianNumberWords(amount);
//         const capitalizedWords = words.split(' ')
//             .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
//             .join(' ');

//         return `${currency} ${capitalizedWords} Only`;
//     };

//     if (isLoading) {
//         return (
//             <div className="sip-container text-center py-5">
//                 <Spinner animation="border" variant="primary" />
//                 <p className="mt-2">Loading sales order details...</p>
//             </div>
//         );
//     }

//     if (!salesData) {
//         return (
//             <div className="sip-container text-center py-5">
//                 <div className="alert alert-warning">No sales order data found</div>
//             </div>
//         );
//     }

//     // Calculate values for international invoice
//     const taxableValue = rows.reduce((sum, row) => sum + (parseFloat(row.totalcurrency) || 0), 0);
//     const exportCharges = parseFloat(salesData.exportpreperationchargescurrency) || 0;
//     const grandTotal = Math.round(taxableValue + exportCharges);

//     const totalQuantity = rows.reduce((sum, row) => sum + parseFloat(row.quantity || 0), 0);

//     // Data mapping from response
//     const companyData = salesData.company || {};
//     const companyAddress = companyData.companyMultipleAddresses?.[0];

//     // Get customer address from response
//     const customerAddress = salesData.customeraddress?.customeraddress ||
//         salesData.billto?.customeraddress ||
//         salesData.shipto?.customeraddress;

//     // Get contact number from response
//     const customerContactNo = salesData.customer?.contactno ||
//         salesData.contactno;

//     // Get LUT/Bond data from response
//     // const lutBondNo = salesData.lutbondno || "N/A";
//     const lutBond = salesData ?
//         `${(salesData.lutbondno)}   ${formatDate(salesData.lutbonddate)}` :
//         "N/A";
//     const lutPeriod = salesData.lutbonddate ?
//         `From ${formatDate(salesData.fromdate)} To ${formatDate(salesData.todate)}` :
//         "N/A";

//     // Get shipping bill data from response
//     const shippingBillType = salesData.typeofshippingbill || "N/A";
//     const drawbackAccountNo = salesData.drawbackacno || "N/A";
//     const chapterHeading = salesData.chapterheading || "N/A";
//     const tariffItem = salesData.tariffitem || "NA";
//     const exportDescription = salesData.description || "N/A";
//     const drawbackRate = salesData.drawbackrate || "N/A";

//     // Get weights and boxes from response
//     const noOfBoxes = salesData.noofboxes || "N/A";
//     const netWeight = salesData.netweightofboxes || "N/A";
//     const grossWeight = salesData.grossweightofboxes || "N/A";

//     const handlePrint = () => {
//         const printStyle = document.createElement('style');
//         printStyle.innerHTML = `
//         @page {
//             margin: 0.7cm 0.5cm 1.2cm 0.5cm;

//             @bottom-left {
//                 content: "SYNERGY Mechanics Pvt. Ltd. | ${new Date().toLocaleDateString()}";
//                 font-size: 8px;
//                 font-family: Arial;
//             }

//             @bottom-center {
//                 content: "Page " counter(page) " of " counter(pages);
//                 font-size: 8px;
//                 font-family: Arial;
//             }

//             @bottom-right {
//                 content: "Invoice: ${salesData?.invoiceno || 'N/A'}";
//                 font-size: 8px;
//                 font-family: Arial;
//             }
//         }

//         @media print {
//             body { 
//                 margin: 0 !important;
//                 padding: 0 !important;
//                 font-size: 10px !important;
//             }

//             .sip-print-button { 
//                 display: none !important; 
//             }

//             /* FORCE HEADER SIZE IN PRINT */
//             .sip-title {
//                 font-size: 18px !important;
//                 margin-top: 35px !important;
//                 font-weight: bold !important;
//             }

//             .sip-logo {
//                 width: 100px !important;
//                 height: 100px !important;
//             }

//             .sip-logo img {
//                 width: 100% !important;
//                 height: 100% !important;
//                 object-fit: contain !important;
//             }

//             /* SIGNATURE SECTION FIX */
//             .sip-signature-section {
//                 padding-top: 0px !important;
//                 position: relative !important;
//             }

//             .sip-signature-section > div:first-child {
//                 margin-bottom: 30px !important;
//             }
//         }
//     `;
//         document.head.appendChild(printStyle);

//         window.print();

//         setTimeout(() => {
//             document.head.removeChild(printStyle);
//         }, 1000);
//     };

//     return (
//         <div className="sip-container">
//             <div className="sip-print-button d-flex gap-2 justify-content-center mb-3">
//                 <button className="btn btn-primary" onClick={handlePrint}>
//                     🖨️ Print Invoice
//                 </button>
//             </div>

//             {/* Printable Content */}
//             <div
//                 id="invoice-print-content"
//                 style={{
//                     width: "100%",
//                     backgroundColor: "white",
//                     fontSize: "10px",
//                     fontFamily: "Arial, sans-serif",
//                     lineHeight: "1.2",
//                 }}
//             >
//                 {/* Header Section */}
//                 <div className="sip-header">
//                     <div
//                         className="sip-logo"
//                         style={{
//                             width: "100px",
//                             height: "100px",
//                             overflow: "hidden",
//                         }}
//                     >
//                         <img
//                             src="/assets/company-logo.png"
//                             alt="Company Logo"
//                             style={{
//                                 height: '100%',
//                                 width: '100%',
//                                 objectFit: 'contain'
//                             }}
//                         />
//                     </div>
//                     <div className="sip-title">COMMERCIAL INVOICE</div>
//                 </div>

//                 {/* Subtitle */}
//                 <div className="sip-subtitle">
//                     (SUPPLY MEANT FOR EXPORT/SUPPLY TO SEZ UNIT OR SEZ DEVELOPER FOR
//                     AUTHORISED OPERATIONS UNDER BOND OR LETTER OF UNDERTAKING WITHOUT
//                     PAYMENT OF IGST)
//                 </div>

//                 {/* Company Details and Invoice Details */}
//                 <table className="sip-main-table">
//                     <tbody>
//                         <tr>
//                             <td className="sip-company-details">
//                                 <strong style={{ fontSize: "10px" }}>{companyData.companyname || "SYNERGY Mechanics Pvt. Ltd"}</strong>
//                                 <br />
//                                 <strong style={{ fontSize: "10px" }}>Works :-</strong>{" "}
//                                 {companyAddress?.address || "W-95/96, MIDC , Phase II, Dombivli - (E) 421203, Mumbai India."}
//                                 <br />
//                                 <strong style={{ fontSize: "10px" }}>Ph. No.: -</strong>{" "}
//                                 {companyData.workcontactno || "8149306088"}
//                                 <br />
//                                 <strong style={{ fontSize: "10px" }}>Office-</strong>{" "}
//                                 {companyData.officeaddress || "2nd Floor, Magnolia, Eden Woods Complex, Gladys Alwares Road, Thane (W) 400610, Mumbai India."}
//                                 <br />
//                                 <strong style={{ fontSize: "10px" }}>Ph. No. :-</strong>{" "}
//                                 {companyData.officecontactno || "9820855876"}
//                                 <br />
//                                 <strong style={{ fontSize: "10px" }}>GSTIN/UIN:</strong> {companyData.gstno || "27AANC54868A1Z3"}
//                                 <br />
//                                 <strong style={{ fontSize: "10px" }}>State Name :</strong>{" "}
//                                 {companyAddress?.state?.statename || "Maharashtra"},{" "}
//                                 <strong style={{ fontSize: "10px" }}>Code :</strong>{" "}
//                                 {companyAddress?.state?.statecode || "27"}
//                                 <br />
//                                 <strong style={{ fontSize: "10px" }}>E-Mail :</strong>{" "}
//                                 {companyData.email || "office@synergymechanics.com"}
//                             </td>

//                             {/* Invoice Details */}
//                             <td className="sip-invoice-details">
//                                 <table className="sip-inner-table">
//                                     <tbody>
//                                         <tr>
//                                             <td className="sip-label">Invoice No.</td>
//                                             <td>
//                                                 <strong style={{ fontSize: "10px" }}>:</strong>{" "}
//                                                 {salesData.invoiceno || "N/A"}
//                                             </td>
//                                         </tr>
//                                         <tr>
//                                             <td className="sip-label">Date</td>
//                                             <td>
//                                                 <strong style={{ fontSize: "10px" }}>:</strong>{" "}
//                                                 {formatDate(salesData.invoicedate) || "N/A"}
//                                             </td>
//                                         </tr>
//                                         <tr>
//                                             <td colSpan="2">&nbsp;</td>
//                                         </tr>
//                                         <tr>
//                                             <td className="sip-label">Mode/Terms of Payment</td>
//                                             <td>
//                                                 <strong style={{ fontSize: "10px" }}>:</strong>{" "}
//                                                 {salesData.customer?.paymentterm || "N/A"}
//                                             </td>
//                                         </tr>
//                                         <tr>
//                                             <td colSpan="2">&nbsp;</td>
//                                         </tr>
//                                         <tr>
//                                             <td className="sip-label">Buyer's Order No.</td>
//                                             <td>
//                                                 <strong style={{ fontSize: "10px" }}>:</strong>{" "}
//                                                 {salesData.buyerorderno || "N/A"}
//                                             </td>
//                                         </tr>
//                                     </tbody>
//                                 </table>
//                             </td>
//                         </tr>
//                     </tbody>
//                 </table>

//                 {/* Buyer & Shipping */}
//                 <table className="sip-main-table">
//                     <tbody>
//                         <tr>
//                             <td className="sip-buyer-details">
//                                 <strong style={{ fontSize: "10px" }}>Buyer</strong>
//                                 <br />
//                                 <strong style={{ fontSize: "10px" }}>
//                                     {salesData.customer?.companyname || "N/A"}
//                                 </strong>
//                                 <br />
//                                 {customerAddress || "N/A"}
//                                 <br />
//                                 <strong style={{ fontSize: "10px" }}>Ph. No.:</strong>{" "}
//                                 {customerContactNo || "N/A"}
//                                 <br />
//                                 <strong style={{ fontSize: "10px" }}>Kind Attn.:</strong>{" "}
//                                 {salesData.kindattn || "N/A"}
//                             </td>

//                             <td className="sip-shipping-details">
//                                 <table className="sip-inner-table">
//                                     <tbody>
//                                         <tr>
//                                             <td className="sip-label">Country Of Origin</td>
//                                             <td>
//                                                 <strong style={{ fontSize: "10px" }}>:</strong>{" "}
//                                                 {salesData.countryoforigin || "India"}
//                                             </td>
//                                         </tr>
//                                         <tr>
//                                             <td className="sip-label">Country Of Destination</td>
//                                             <td>
//                                                 <strong style={{ fontSize: "10px" }}>:</strong>{" "}
//                                                 {salesData.countryofdestination || "N/A"}
//                                             </td>
//                                         </tr>
//                                         <tr>
//                                             <td className="sip-label">By Air/Sea</td>
//                                             <td>
//                                                 <strong style={{ fontSize: "10px" }}>:</strong>{" "}
//                                                 {salesData.airsea ? `By ${salesData.airsea.charAt(0).toUpperCase() + salesData.airsea.slice(1)}` : "By Sea"}
//                                             </td>
//                                         </tr>
//                                         <tr>
//                                             <td className="sip-label">Port of Loading</td>
//                                             <td>
//                                                 <strong style={{ fontSize: "10px" }}>:</strong>{" "}
//                                                 {salesData.portofloading || "N/A"}
//                                             </td>
//                                         </tr>
//                                         <tr>
//                                             <td className="sip-label">Port Of Discharge</td>
//                                             <td>
//                                                 <strong style={{ fontSize: "10px" }}>:</strong>{" "}
//                                                 {salesData.portofdischarge || "N/A"}
//                                             </td>
//                                         </tr>
//                                         <tr>
//                                             <td className="sip-label">Incoterm</td>
//                                             <td>
//                                                 <strong style={{ fontSize: "10px" }}>:</strong>{" "}
//                                                 {salesData.incoterms || "N/A"}
//                                             </td>
//                                         </tr>
//                                     </tbody>
//                                 </table>
//                             </td>
//                         </tr>
//                     </tbody>
//                 </table>

//                 {/* Product Table with Export Charges */}
//                 <table className="sip-product-table">
//                     <thead>
//                         <tr>
//                             <th style={{ width: "5%" }}>Sr. No.</th>
//                             <th style={{ width: "45%" }}>Description</th>
//                             <th style={{ width: "15%" }}>Qty in {uom}</th>
//                             <th style={{ width: "20%" }}>Unit Rate in {currency}</th>
//                             <th style={{ width: "25%" }}>Amount in {currency}</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {rows.map((row, index) => (
//                             <tr key={index}>
//                                 <td className="text-center">{index + 1}</td>
//                                 <td>
//                                     <strong style={{ fontSize: "10px" }}>{row.description}</strong>
//                                     {row.productremarks && (
//                                         <div className="product-remarks">{row.productremarks}</div>
//                                     )}
//                                 </td>
//                                 <td className="text-center">
//                                     {formatNumberWithDecimal(row.quantity)}
//                                 </td>
//                                 <td className="text-right">
//                                     {formatNumberWithDecimal(row.unitratecurrency)}
//                                 </td>
//                                 <td className="text-right">
//                                     {formatNumberWithDecimal(row.totalcurrency)}
//                                 </td>
//                             </tr>
//                         ))}

//                         {/* Total Row */}
//                         <tr>
//                             <td></td>
//                             <td colSpan="3" className="text-right sip-total-label"> Sub Total</td>
//                             <td className="text-right sip-total-value">
//                                 {formatNumberWithDecimal(taxableValue)}
//                             </td>
//                         </tr>

//                         {/* Export Preparation Charges Row */}
//                         <tr>
//                             <td></td>
//                             <td colSpan="3">
//                                 <strong style={{ fontSize: "10px" }}>Export Preparation Charges</strong>
//                             </td>
//                             <td className="text-right sip-total-value">
//                                 {formatNumberWithDecimal(exportCharges)}
//                             </td>
//                         </tr>

//                         <tr>
//                             <td colSpan="5">
//                                 <strong style={{ fontSize: "10px" }}>No. of Boxes:</strong> {noOfBoxes} &nbsp;&nbsp;
//                                 <strong style={{ fontSize: "10px" }}>Net wt. of Boxes:</strong> {netWeight} Kgs &nbsp;&nbsp;
//                                 <strong style={{ fontSize: "10px" }}>Gross wt. of Boxes:</strong> {grossWeight} Kgs
//                             </td>
//                         </tr>

//                         <tr>
//                             <td colSpan="3">
//                                 <strong style={{ fontSize: "10px" }}>LUT/Bond No:</strong>{" "}
//                                 {lutBond}
//                             </td>
//                             {/* <td colSpan="2">
//                                 <strong style={{ fontSize: "10px" }}>LUT/Bond No:</strong>{" "}
//                                 {lutBondNo}
//                             </td> */}
//                             <td colSpan="2" className="text-center">
//                                 <strong style={{ fontSize: "10px" }}>{lutPeriod}</strong>
//                             </td>
//                         </tr>

//                         <tr>
//                             <td colSpan="4">
//                                 Amount in words: <strong style={{ fontSize: "10px" }}>{numberToWordsWithCurrency(grandTotal, currency)} </strong>
//                             </td>
//                             <td className="text-right sip-total-value" style={{ fontSize: "11px" }}>
//                                 {formatNumberWithDecimal(grandTotal)}
//                             </td>
//                         </tr>
//                     </tbody>
//                 </table>

//                 {/* Shipping & Signature */}
//                 <div className="sip-shipping-section">
//                     <table className="sip-shipping-signature-table">
//                         <tbody>
//                             <tr>
//                                 <td style={{ width: "50%", verticalAlign: "top", padding: "4px", borderRight: "1px solid black" }}>
//                                     <strong style={{ fontSize: "10px" }}>Type of Shipping Bill :</strong>{" "}
//                                     {shippingBillType}
//                                     <br />
//                                     <strong style={{ fontSize: "10px" }}>Drawback Acc. No.:</strong>{" "}
//                                     {drawbackAccountNo}
//                                     <br />
//                                     <strong style={{ fontSize: "10px" }}>Chapter Heading:</strong>{" "}
//                                     {chapterHeading}
//                                     <br />
//                                     <strong style={{ fontSize: "10px" }}>Tariff Item:</strong>{" "}
//                                     {tariffItem}
//                                     <br />
//                                     <strong style={{ fontSize: "10px" }}>Description:</strong>{" "}
//                                     {exportDescription}
//                                     <br />
//                                     <strong style={{ fontSize: "10px" }}>Drawback Rate:</strong>{" "}
//                                     {drawbackRate}
//                                 </td>
//                                 <td
//                                     style={{
//                                         width: "50%",
//                                         verticalAlign: "top",
//                                         textAlign: "start",
//                                         padding: "4px",
//                                     }}
//                                 >
//                                     For,
//                                     <br />
//                                     <strong style={{ fontSize: "11px" }}>
//                                         SYNERGY MECHANICS PVT. LTD.
//                                     </strong>
//                                     <br />
//                                     <br />
//                                     <br />
//                                     <br />
//                                     Authorised Signatory
//                                 </td>
//                             </tr>
//                         </tbody>
//                     </table>
//                 </div>

//                 {/* Footer Note */}
//                 <div className="sip-footer">This is Computer Generated Invoice *</div>
//             </div>
//         </div>
//     );
// };

// export default SalesInvoicePrintAMI;





import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import axios from 'axios';
import { BASE_URL } from '../../../services/Api';
import { authHeader } from '../../../services/auth-header';

const SalesInvoicePrintAMI = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [salesData, setSalesData] = useState(null);
    const [rows, setRows] = useState([]);
    const [currency, setCurrency] = useState('JPY');
    const [uom, setUom] = useState('Nos.');

    const fetchSalesData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}sales/findById/${id}`, {
                headers: authHeader(),
            });

            const data = response.data;
            setSalesData(data);
            console.log("Fetched sales data:", data);

            if (data.salesItems && data.salesItems.length > 0) {
                const firstItem = data.salesItems[0];
                const itemCurrency = firstItem.currency || 'JPY';
                const itemUom = firstItem.uom || 'Nos.';

                setCurrency(itemCurrency);
                setUom(itemUom);

                setRows(data.salesItems.map(item => ({
                    description: item.product?.description || '-',
                    productremarks: item.productremarks || '',
                    quantity: item.quantity || 0,
                    unitratecurrency: item.unitratecurrency || 0,
                    totalcurrency: item.totalcurrency || 0,
                    uom: item.uom || itemUom,
                })));
            }
        } catch (error) {
            console.error("Error fetching sales data", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchSalesData();
    }, [id]);

    // Format functions
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return 'N/A';
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${day}.${month}.${year}`;
        } catch (error) {
            return 'N/A';
        }
    };

    const formatNumberWithCommas = (num) => {
        if (isNaN(num) || num === null || num === undefined) return '0';
        return parseInt(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const formatNumberWithDecimal = (num) => {
        if (isNaN(num) || num === null || num === undefined) return '0.00';
        return parseFloat(num).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const numberToWordsWithCurrency = (num, currency = 'JPY') => {
        if (isNaN(num) || num === null || num === undefined) {
            return "Zero Only";
        }

        const amount = Math.round(Number(num));

        const getIndianNumberWords = (num) => {
            const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
                'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
                'Eighteen', 'Nineteen'];
            const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
            const scales = ['', 'Thousand', 'Lakh', 'Crore'];

            if (num === 0) return 'Zero';
            if (num < 20) return ones[num];

            let words = '';
            let n = num;
            let scaleIndex = 0;
            const parts = [];

            while (n > 0) {
                if (scaleIndex === 0) {
                    let lastThree = n % 1000;
                    if (lastThree > 0) {
                        let part = '';
                        if (lastThree >= 100) {
                            part += ones[Math.floor(lastThree / 100)] + ' Hundred ';
                            lastThree %= 100;
                        }
                        if (lastThree >= 20) {
                            part += tens[Math.floor(lastThree / 10)] + ' ';
                            lastThree %= 10;
                        }
                        if (lastThree > 0) {
                            part += ones[lastThree] + ' ';
                        }
                        parts.unshift(part.trim() + (scales[scaleIndex] ? ' ' + scales[scaleIndex] : ''));
                    }
                    n = Math.floor(n / 1000);
                    scaleIndex++;
                } else {
                    let lastTwo = n % 100;
                    if (lastTwo > 0) {
                        let part = '';
                        if (lastTwo >= 20) {
                            part += tens[Math.floor(lastTwo / 10)] + ' ';
                            lastTwo %= 10;
                        }
                        if (lastTwo > 0) {
                            part += ones[lastTwo] + ' ';
                        }
                        parts.unshift(part.trim() + ' ' + scales[scaleIndex]);
                    } else if (n % 100 !== 0) {
                        parts.unshift(scales[scaleIndex]);
                    }
                    n = Math.floor(n / 100);
                    scaleIndex++;
                }
            }

            return parts.join(' ').trim();
        };

        const words = getIndianNumberWords(amount);
        const capitalizedWords = words.split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');

        return `${currency} ${capitalizedWords} Only`;
    };

    if (isLoading) {
        return (
            <div style={{
                fontFamily: 'Arial, sans-serif',
                textAlign: 'center',
                padding: '40px 0'
            }}>
                <Spinner animation="border" variant="primary" />
                <p style={{ marginTop: '8px' }}>Loading sales order details...</p>
            </div>
        );
    }

    if (!salesData) {
        return (
            <div style={{
                fontFamily: 'Arial, sans-serif',
                textAlign: 'center',
                padding: '40px 0'
            }}>
                <div className="alert alert-warning">No sales order data found</div>
            </div>
        );
    }

    // Calculate values for international invoice
    const taxableValue = rows.reduce((sum, row) => sum + (parseFloat(row.totalcurrency) || 0), 0);
    const exportCharges = parseFloat(salesData.exportpreperationchargescurrency) || 0;
    const grandTotal = Math.round(taxableValue + exportCharges);

    // Data mapping from response
    const companyData = salesData.company || {};
    const companyAddress = companyData.companyMultipleAddresses?.[0];
    const customerAddress = salesData.customeraddress?.customeraddress ||
        salesData.billto?.customeraddress ||
        salesData.shipto?.customeraddress;
    const customerContactNo = salesData.customer?.contactno || salesData.contactno;

    const lutBond = salesData ?
        `${(salesData.lutbondno)}   ${formatDate(salesData.lutbonddate)}` :
        "N/A";
    const lutPeriod = salesData.lutbonddate ?
        `From ${formatDate(salesData.fromdate)} To ${formatDate(salesData.todate)}` :
        "N/A";

    const shippingBillType = salesData.typeofshippingbill || "N/A";
    const drawbackAccountNo = salesData.drawbackacno || "N/A";
    const chapterHeading = salesData.chapterheading || "N/A";
    const tariffItem = salesData.tariffitem || "NA";
    const exportDescription = salesData.description || "N/A";
    const drawbackRate = salesData.drawbackrate || "N/A";

    const noOfBoxes = salesData.noofboxes || "N/A";
    const netWeight = salesData.netweightofboxes || "N/A";
    const grossWeight = salesData.grossweightofboxes || "N/A";

    // Calculate rows needed to fill first page - ALWAYS show 8 product rows on first page
    const totalProductRows = 12;
    const actualRows = rows.length;
    const emptyRowsNeeded = Math.max(0, totalProductRows - actualRows);

    const handlePrint = () => {
        const printStyle = document.createElement('style');
        printStyle.innerHTML = `
        @page {
            margin: 0.7cm 0.5cm 1.2cm 0.5cm;
            size: A4;
        }
        
        @media print {
            body { 
                margin: 0 !important;
                padding: 0 !important;
                font-size: 11px !important;
            }
            
            .sip-print-button { 
                display: none !important; 
            }
            
            /* HEADER MARGIN FIX */
            .sip-title {
                font-size: 19px !important;
                margin: 0 !important;
                padding: 0 !important;
                font-weight: bold !important;
            }
            
            .sip-logo {
                width: 100px !important;
                height: 100px !important;
                margin: 0 !important;
                padding: 0 !important;
            }
            
            .sip-logo img {
                width: 100% !important;
                height: 100% !important;
                object-fit: contain !important;
                margin: 0 !important;
                padding: 0 !important;
            }
            
            /* PAGE BREAK CONTROL */
            .page-break {
                page-break-before: always;
            }
            
            .product-table {
                page-break-inside: auto;
            }
            
            .product-row {
                page-break-inside: avoid;
            }
            
            .empty-row {
                height: 25px !important;
                border: 1px solid black !important;
            }
            
            .first-page {
                min-height: 29.7cm;
                display: flex;
                flex-direction: column;
            }
            
            .first-page-content {
                flex: 1;
            }
            
            /* SHIPPING SECTION FIX */
            .no-break {
                page-break-inside: avoid !important;
                break-inside: avoid !important;
            }
        }
    `;
        document.head.appendChild(printStyle);

        window.print();

        setTimeout(() => {
            document.head.removeChild(printStyle);
        }, 1000);
    };

    // Inline styles
    const containerStyle = {
        fontFamily: 'Arial, sans-serif',
        fontSize: '11px',
        background: 'white',
        padding: '10px',
        margin: '0 auto'
    };

    const screenContainerStyle = {
        ...containerStyle,
        width: '21cm',
        minHeight: '29.7cm',
        padding: '1cm',
        margin: '0 auto',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        background: 'white'
    };

    const printButtonStyle = {
        display: 'flex',
        gap: '8px',
        justifyContent: 'center',
        marginBottom: '12px'
    };

    const invoiceContentStyle = {
        width: "100%",
        backgroundColor: "white",
        fontSize: "11px",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.2",
        margin: 0,
        padding: 0
    };

    const headerStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        margin: '0',
        padding: '0'
    };

    const titleStyle = {
        fontSize: '19px',
        fontWeight: 'bold',
        textAlign: 'center',
        textTransform: 'uppercase',
        flexGrow: '1',
        margin: '0',
        padding: '0'
    };

    const logoStyle = {
        width: '100px',
        height: '100px',
        overflow: 'hidden',
        margin: '0',
        padding: '0'
    };

    const logoImgStyle = {
        height: '100%',
        width: '100%',
        objectFit: 'contain'
    };

    const subtitleStyle = {
        textAlign: 'center',
        fontSize: '11px',
        margin: '2px 0',
        border: '1px solid black',
        padding: '3px 2px',
        backgroundColor: '#f5f5f5',
        fontWeight: 'bold'
    };

    const mainTableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        marginBottom: '2px',
        border: '1px solid black'
    };

    const companyDetailsStyle = {
        width: '50%',
        verticalAlign: 'top',
        borderRight: '1px solid black',
        padding: '4px',
        lineHeight: '1.3'
    };

    const invoiceDetailsStyle = {
        width: '50%',
        verticalAlign: 'top',
        padding: '4px'
    };

    const innerTableStyle = {
        width: '100%',
        borderCollapse: 'collapse'
    };

    const innerTableCellStyle = {
        padding: '1px 2px',
        verticalAlign: 'top',
        border: 'none'
    };

    const labelStyle = {
        width: '45%',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        fontSize: '11px'
    };

    const buyerDetailsStyle = {
        width: '50%',
        verticalAlign: 'top',
        borderRight: '1px solid black',
        padding: '4px',
        lineHeight: '1.3'
    };

    const shippingDetailsStyle = {
        width: '50%',
        verticalAlign: 'top',
        padding: '4px'
    };

    const productTableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        marginBottom: '8px',
        border: '1px solid black'
    };

    const productTableCellStyle = {
        border: '1px solid black',
        padding: '4px',
        fontSize: '11px',
        lineHeight: '1.2',
        height: '25px'
    };

    const productTableHeaderStyle = {
        ...productTableCellStyle,
        textAlign: 'center',
        fontWeight: 'bold',
        backgroundColor: '#f8f9fa'
    };

    const emptyTableCellStyle = {
        ...productTableCellStyle,
        border: '1px solid black',
        height: '25px'
    };

    const productRemarksStyle = {
        fontSize: '10px',
        color: '#666',
        fontStyle: 'italic',
        marginTop: '2px',
        lineHeight: '1.1'
    };

    const totalLabelStyle = {
        fontWeight: 'bold',
        textAlign: 'right',
        paddingRight: '10px'
    };

    const totalValueStyle = {
        fontWeight: 'bold',
        backgroundColor: '#f8f9fa'
    };

    const shippingSectionStyle = {
        border: '1px solid black',
        marginBottom: '8px'
    };

    const shippingSignatureTableStyle = {
        width: '100%',
        borderCollapse: 'collapse'
    };

    const footerStyle = {
        textAlign: 'center',
        marginTop: '10px',
        fontSize: '10px',
        fontStyle: 'italic'
    };

    const firstPageContentStyle = {
        minHeight: '24cm',
        display: 'flex',
        flexDirection: 'column'
    };

    const productTableContainerStyle = {
        flex: '1',
        display: 'flex',
        flexDirection: 'column'
    };

    return (
        <div style={screenContainerStyle}>
            <div className="sip-print-button d-flex gap-2 justify-content-center" style={{ marginBottom: "10px", textAlign: "center", padding: "2px" }}>
                <button className="btn btn-secondary" onClick={() => navigate(-1)}>
                    ← Back
                </button>
                <button className="btn btn-primary" onClick={handlePrint}>
                    🖨️ Print Invoice
                </button>
            </div>

            <div id="invoice-print-content" style={invoiceContentStyle}>
                {/* First Page - ALWAYS show full page with 8 product rows */}
                <div className="first-page">
                    <div style={firstPageContentStyle}>
                        {/* Header Section */}
                        <div style={headerStyle}>
                            <div style={titleStyle} className="sip-title">COMMERCIAL INVOICE</div>
                            <div style={logoStyle} className="sip-logo">
                                <img
                                    src="/assets/company-logo.png"
                                    alt="Company Logo"
                                    style={logoImgStyle}
                                />
                            </div>
                        </div>

                        <div style={subtitleStyle}>
                            (SUPPLY MEANT FOR EXPORT/SUPPLY TO SEZ UNIT OR SEZ DEVELOPER FOR
                            AUTHORISED OPERATIONS UNDER BOND OR LETTER OF UNDERTAKING WITHOUT
                            PAYMENT OF IGST)
                        </div>

                        {/* Company Details and Invoice Details */}
                        <table style={mainTableStyle}>
                            <tbody>
                                <tr>
                                    <td style={companyDetailsStyle}>
                                        <strong style={{ fontSize: "11px", fontStyle: "italic", fontWeight: "bold" }}>
                                            {companyData.companyname || "SYNERGY Mechanics Pvt. Ltd"}
                                        </strong>
                                        <br />
                                        <strong style={{ fontSize: "11px" }}>Works :-</strong>{" "}
                                        {companyAddress?.address || "W-95/96, MIDC , Phase II, Dombivli - (E) 421203, Mumbai India."}
                                        <br />
                                        <strong style={{ fontSize: "11px" }}>Ph. No.: -</strong>{" "}
                                        {companyData.workcontactno || "8149306088"}
                                        <br />
                                        <strong style={{ fontSize: "11px" }}>Office-</strong>{" "}
                                        {companyData.officeaddress || "2nd Floor, Magnolia, Eden Woods Complex, Gladys Alwares Road, Thane (W) 400610, Mumbai India."}
                                        <br />
                                        <strong style={{ fontSize: "11px" }}>Ph. No. :-</strong>{" "}
                                        {companyData.officecontactno || "9820855876"}
                                        <br />
                                        <strong style={{ fontSize: "11px" }}>GSTIN/UIN:</strong> {companyData.gstno || "27AANC54868A1Z3"}
                                        <br />
                                        <strong style={{ fontSize: "11px" }}>State Name :</strong>{" "}
                                        {companyAddress?.state?.statename || "Maharashtra"},{" "}
                                        <strong style={{ fontSize: "11px" }}>Code :</strong>{" "}
                                        {companyAddress?.state?.statecode || "27"}
                                        <br />
                                        <strong style={{ fontSize: "11px" }}>E-Mail :</strong>{" "}
                                        {companyData.email || "office@synergymechanics.com"}
                                    </td>

                                    <td style={invoiceDetailsStyle}>
                                        <table style={innerTableStyle}>
                                            <tbody>
                                                <tr>
                                                    <td style={labelStyle}>Invoice No.</td>
                                                    <td style={innerTableCellStyle}>
                                                        <strong style={{ fontSize: "11px" }}>:</strong>{" "}
                                                        {salesData.invoiceno || "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={labelStyle}>Date</td>
                                                    <td style={innerTableCellStyle}>
                                                        <strong style={{ fontSize: "11px" }}>:</strong>{" "}
                                                        {formatDate(salesData.invoicedate) || "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="2" style={innerTableCellStyle}>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td style={labelStyle}>Mode/Terms of Payment</td>
                                                    <td style={innerTableCellStyle}>
                                                        <strong style={{ fontSize: "11px" }}>:</strong>{" "}
                                                        {salesData.customer?.paymentterm || "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="2" style={innerTableCellStyle}>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td style={labelStyle}>Buyer's Order No.</td>
                                                    <td style={innerTableCellStyle}>
                                                        <strong style={{ fontSize: "11px" }}>:</strong>{" "}
                                                        {salesData.buyerorderno || "N/A"}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Buyer & Shipping */}
                        <table style={mainTableStyle}>
                            <tbody>
                                <tr>
                                    <td style={buyerDetailsStyle}>
                                        <strong style={{ fontSize: "11px" }}>Buyer</strong>
                                        <br />
                                        <strong style={{ fontSize: "11px" }}>
                                            {salesData.customer?.companyname || "N/A"}
                                        </strong>
                                        <br />
                                        {customerAddress || "N/A"}
                                        <br />
                                        <strong style={{ fontSize: "11px" }}>Ph. No.:</strong>{" "}
                                        {customerContactNo || "N/A"}
                                        <br />
                                        <strong style={{ fontSize: "11px" }}>Kind Attn.:</strong>{" "}
                                        {salesData.kindattn || "N/A"}
                                    </td>

                                    <td style={shippingDetailsStyle}>
                                        <table style={innerTableStyle}>
                                            <tbody>
                                                <tr>
                                                    <td style={labelStyle}>Country Of Origin</td>
                                                    <td style={innerTableCellStyle}>
                                                        <strong style={{ fontSize: "11px" }}>:</strong>{" "}
                                                        {salesData.countryoforigin || "India"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={labelStyle}>Country Of Destination</td>
                                                    <td style={innerTableCellStyle}>
                                                        <strong style={{ fontSize: "11px" }}>:</strong>{" "}
                                                        {salesData.countryofdestination || "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={labelStyle}>By Air/Sea</td>
                                                    <td style={innerTableCellStyle}>
                                                        <strong style={{ fontSize: "11px" }}>:</strong>{" "}
                                                        {salesData.airsea ? `By ${salesData.airsea.charAt(0).toUpperCase() + salesData.airsea.slice(1)}` : "By Sea"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={labelStyle}>Port of Loading</td>
                                                    <td style={innerTableCellStyle}>
                                                        <strong style={{ fontSize: "11px" }}>:</strong>{" "}
                                                        {salesData.portofloading || "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={labelStyle}>Port Of Discharge</td>
                                                    <td style={innerTableCellStyle}>
                                                        <strong style={{ fontSize: "11px" }}>:</strong>{" "}
                                                        {salesData.portofdischarge || "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={labelStyle}>Incoterm</td>
                                                    <td style={innerTableCellStyle}>
                                                        <strong style={{ fontSize: "11px" }}>:</strong>{" "}
                                                        {salesData.incoterms || "N/A"}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Product Table - ALWAYS show 8 rows on first page */}
                        <div style={productTableContainerStyle}>
                            <table style={productTableStyle} className="product-table">
                                <thead>
                                    <tr>
                                        <th style={{ ...productTableHeaderStyle, width: "5%" }}>Sr. No.</th>
                                        <th style={{ ...productTableHeaderStyle, width: "45%" }}>Description</th>
                                        <th style={{ ...productTableHeaderStyle, width: "15%" }}>Qty in {uom}</th>
                                        <th style={{ ...productTableHeaderStyle, width: "20%" }}>Unit Rate in {currency}</th>
                                        <th style={{ ...productTableHeaderStyle, width: "25%" }}>Amount in {currency}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* Actual Product Rows */}
                                    {rows.map((row, index) => (
                                        <tr key={index} className="product-row">
                                            <td style={{ ...productTableCellStyle, textAlign: 'center' }}>{index + 1}</td>
                                            <td style={productTableCellStyle}>
                                                <strong style={{ fontSize: "11px" }}>{row.description}</strong>
                                                {row.productremarks && (
                                                    <div style={productRemarksStyle}>{row.productremarks}</div>
                                                )}
                                            </td>
                                            <td style={{ ...productTableCellStyle, textAlign: 'center' }}>
                                                {formatNumberWithDecimal(row.quantity)}
                                            </td>
                                            <td style={{ ...productTableCellStyle, textAlign: 'right' }}>
                                                {formatNumberWithDecimal(row.unitratecurrency)}
                                            </td>
                                            <td style={{ ...productTableCellStyle, textAlign: 'right' }}>
                                                {formatNumberWithDecimal(row.totalcurrency)}
                                            </td>
                                        </tr>
                                    ))}

                                    {/* Empty Rows to ALWAYS fill 8 rows on first page */}
                                    {Array.from({ length: emptyRowsNeeded }).map((_, index) => (
                                        <tr key={`empty-${index}`} className="empty-row">
                                            <td style={emptyTableCellStyle}>&nbsp;</td>
                                            <td style={emptyTableCellStyle}>&nbsp;</td>
                                            <td style={emptyTableCellStyle}>&nbsp;</td>
                                            <td style={emptyTableCellStyle}>&nbsp;</td>
                                            <td style={emptyTableCellStyle}>&nbsp;</td>
                                        </tr>
                                    ))}

                                    {/* Total Rows */}
                                    <tr>
                                        <td style={productTableCellStyle}></td>
                                        <td colSpan="3" style={{ ...productTableCellStyle, ...totalLabelStyle }}> Sub Total</td>
                                        <td style={{ ...productTableCellStyle, ...totalValueStyle, textAlign: 'right' }}>
                                            {formatNumberWithDecimal(taxableValue)}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={productTableCellStyle}></td>
                                        <td colSpan="3" style={productTableCellStyle}>
                                            <strong style={{ fontSize: "11px" }}>Export Preparation Charges</strong>
                                        </td>
                                        <td style={{ ...productTableCellStyle, ...totalValueStyle, textAlign: 'right' }}>
                                            {formatNumberWithDecimal(exportCharges)}
                                        </td>
                                    </tr>

                                    {/* No. of Boxes - Separate Row */}
                                    <tr>
                                        <td colSpan="5" style={productTableCellStyle}>
                                            <strong style={{ fontSize: "10px" }}>No. of Boxes:</strong> {noOfBoxes} <br />
                                            <strong style={{ fontSize: "10px" }}>Net wt. of Boxes:</strong> {netWeight} Kgs <br />
                                            <strong style={{ fontSize: "10px" }}>Gross wt. of Boxes:</strong> {grossWeight} Kgs
                                        </td>
                                    </tr>

                                    <tr>
                                        <td colSpan="3" style={productTableCellStyle}>
                                            <strong style={{ fontSize: "11px" }}>LUT/Bond No:</strong>{" "}
                                            {lutBond}
                                        </td>
                                        <td colSpan="2" style={{ ...productTableCellStyle, textAlign: 'center' }}>
                                            <strong style={{ fontSize: "11px" }}>{lutPeriod}</strong>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td colSpan="4" style={productTableCellStyle}>
                                            Amount in words: <strong style={{ fontSize: "11px" }}>{numberToWordsWithCurrency(grandTotal, currency)} </strong>
                                        </td>
                                        <td style={{ ...productTableCellStyle, ...totalValueStyle, textAlign: 'right', fontSize: "12px" }}>
                                            {formatNumberWithDecimal(grandTotal)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* Shipping & Signature */}
                        <div style={shippingSectionStyle} className="no-break">
                            <table style={shippingSignatureTableStyle} className="no-break">
                                <tbody>
                                    <tr>
                                        <td style={{ width: "50%", verticalAlign: "top", padding: "4px", borderRight: "1px solid black" }}>
                                            <strong style={{ fontSize: "11px" }}>Type of Shipping Bill :</strong>{" "}
                                            {shippingBillType}
                                            <br />
                                            <strong style={{ fontSize: "11px" }}>Drawback Acc. No.:</strong>{" "}
                                            {drawbackAccountNo}
                                            <br />
                                            <strong style={{ fontSize: "11px" }}>Chapter Heading:</strong>{" "}
                                            {chapterHeading}
                                            <br />
                                            <strong style={{ fontSize: "11px" }}>Tariff Item:</strong>{" "}
                                            {tariffItem}
                                            <br />
                                            <strong style={{ fontSize: "11px" }}>Description:</strong>{" "}
                                            {exportDescription}
                                            <br />
                                            <strong style={{ fontSize: "11px" }}>Drawback Rate:</strong>{" "}
                                            {drawbackRate}
                                        </td>
                                        <td style={{ width: "50%", verticalAlign: "top", textAlign: "start", padding: "4px" }}>
                                            For,
                                            <br />
                                            <strong style={{ fontSize: "12px", fontStyle: "italic", fontWeight: "bold" }}>
                                                SYNERGY MECHANICS PVT. LTD.
                                            </strong>
                                            <br />
                                            <br />
                                            <br />
                                            <br />
                                            Authorised Signatory
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div style={footerStyle}>This is Computer Generated Invoice *</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SalesInvoicePrintAMI;